module.exports = __webpack_public_path__ + "assets/img/4.84523c5b.png";